import { useState } from "react"
import PlannerHeader from "@/modules/planner/components/header/planner-header"
import StudyTime from "@/modules/planner/components/study-time"
import CourseCards from "@/modules/planner/components/course-cards"
import WeeklyObjectives from "@/modules/planner/components/weekly-objectives"
import type { Course } from "@/modules/courses/entities/courses"
import { PRODUCT_TOUR_STEPS } from "@/modules/product-tour/constants/steps"

export default function Planner() {
  const [activeCourses, setActiveCourses] = useState<Course[]>([])

  return (
    <section
      id={PRODUCT_TOUR_STEPS.PLANNER_START}
      className="grid h-full w-full grid-rows-[max-content,1fr] gap-4 overflow-hidden"
    >
      <div className="grid grid-cols-1 gap-4 px-6">
        <PlannerHeader />
        <StudyTime activeCourses={activeCourses} />
        <CourseCards activeCourses={activeCourses} />
      </div>
      <div className="grid grid-cols-1 gap-4 pb-6 pl-6">
        <WeeklyObjectives activeCourses={activeCourses} setActiveCourses={setActiveCourses} />
      </div>
    </section>
  )
}
